import React, { useEffect } from 'react'
import { GenericTable } from '../_EOS/Table'
import { pickingRouteTableHeaderConfig } from './config'
import { Box, Paper } from '@mui/material'
import { PickingRoute } from '../../interfaces/PickingRouteAdmin/PickingRoute'
import { useZones } from '../../hooks'
import { IPickingRouteState, IPickingRouteValidationState } from '../../interfaces/PickingRoute/PickingRouteState'

interface WorkOrderBlogProps {
  pickingRoutes: PickingRoute[]
  isLoading: boolean
}

export const PickingRouteTable: React.FC<WorkOrderBlogProps> = ({
  pickingRoutes,
  isLoading
}) => {

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(()=> {
      getZones()
  },[])

const pickingRouteValidationState: IPickingRouteValidationState[] = [
  {
    value: 3,
    name: 'Validada'
  },
  {
    value: 2,
    name: 'No Validada'
  }
]

const pickingRouteStates : IPickingRouteState[] = [
  {
    value: 1,
    name: 'No Iniciada'
  },
  {
    value: 2,
    name: 'Iniciada'
  },
  {
    value: 3,
    name: 'Terminada'
  }
]

const headers = pickingRouteTableHeaderConfig(zones, pickingRouteStates, pickingRouteValidationState)

  return (
    <Box overflow={'auto'} maxHeight={'250px'} component={Paper}>
      <GenericTable<PickingRoute>
        headersConfig={headers}
        data={pickingRoutes}
        IDKey={'pickingRouteId'}
        noResultsText='No hay rutas de picking creadas para esta OT'
        isLoading={isLoading}
      />
    </Box>
  )
}
